import React, { useEffect } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import funnel from "../../styles/Funnel.module.css";
import axios from "axios";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { NumericFormat } from "react-number-format";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import { useCookies } from "react-cookie";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";

let CustomSelect = styled(Select)(({ theme }) => ({
  width: "90%",
  "&.MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
});

export default function BuyingChanceState({
  formData,
  setFormData,
  errors,
  setErrors,
  errorsu,
  setErrorsu,
}) {
  const [state, setState] = React.useState(null);
  const [suburbList, setSuburbList] = React.useState([]);
  const Router = useRouter();

  const handleChangeState = (event) => {
    setState(event.target.value);
    setFormData({
      ...formData,
      state: event.target.value,
    });
    axios
      .get(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/property/suburb/list/${event.target.value}/`
      )
      .then((res) => {
        setSuburbList(res.data);
      })
      .catch((err) => {
        if (err.code == "ERR_NETWORK") {
          Router.push("/error/");
        }
      });
    setErrors(false);
  };

  let helperTextState;
  if (errors == true) {
    CustomSelect = styled(Select)(() => ({
      "&.MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "red",
        },
        "&:hover fieldset": {
          borderColor: "red",
        },
        "&.Mui-focused fieldset": {
          borderColor: "red",
        },
      },
    }));
    helperTextState = "Please select a state!";
  } else {
    CustomSelect = styled(Select)(() => ({
      "&.MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "var(--primary-color)",
        },
        "&:hover fieldset": {
          borderColor: "var(--primary-color)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "var(--primary-color)",
        },
      },
    }));
    helperTextState = "";
  }

  const suburbs = [];
  suburbList.map((name) => {
    suburbs.push({
      title: name.suburb_name + "," + name.state + "," + name.postcode,
      suburb_id: name.suburb_id,
    });
  });

  const handleChangeSuburb = (event, value) => {
    setFormData({
      ...formData,
      suburb_id: value.suburb_id,
    });
    setErrorsu(false);
  };

  let disable_auto;
  if (state === null) {
    disable_auto = "disabled";
  }
  let suItem;
  for (let item in suburbs) {
    if (formData.suburb == suburbs[item].title) {
      suItem = suburbs[item];
    }
  }

  let errorSububr;
  let helperTextSububr;
  if (errorsu == true) {
    errorSububr = "error";
    helperTextSububr = "Suburb value cannot be empty!";
  } else {
    errorSububr = "";
    helperTextSububr = "";
  }

  const data = [
    { value: "act", label: "ACT" },
    { value: "nsw", label: "NSW" },
    { value: "wa", label: "WA" },
    { value: "vic", label: "VIC" },
    { value: "nt", label: "NT" },
    { value: "qld", label: "QLD" },
    { value: "sa", label: "SA" },
    { value: "tas", label: "TAS" },
  ];

  return (
    <>
      <div className={funnel.boxQn}>
        <div className={funnel.funnelColumnField}>
          <h4 className={funnel.h4TextFunnel}>Select your state and more</h4>
          <div className={funnel.funnelRowField}>
            <div className={funnel.FunnelFieldState}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ "&.Mui-focused": { color: "var(--primary-color)" } }}
                >
                  State
                </InputLabel>
                <CustomSelect
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={state}
                  label="State"
                  onChange={handleChangeState}
                >
                  {data.map((data) => (
                    <MenuItem value={data.value}>{data.label}</MenuItem>
                  ))}
                </CustomSelect>
                <FormHelperText sx={{ color: "red" }}>
                  {helperTextState}
                </FormHelperText>
              </FormControl>
            </div>
            <div className={funnel.FunnelFieldSuburb}>
              <FormControl fullWidth>
                <Autocomplete
                  loading
                  sx={{ margin: 0 }}
                  freeSolo
                  id="highlights-demo"
                  disabled={disable_auto}
                  options={suburbs}
                  onChange={handleChangeSuburb}
                  value={suItem}
                  getOptionLabel={(option) => option.title}
                  renderInput={(params) => (
                    <CssTextField
                      {...params}
                      error={errorSububr}
                      helperText={helperTextSububr}
                      value={formData.suburb_id}
                      placeholder="Suburb"
                      sx={{ mt: 0 }}
                      margin="normal"
                    />
                  )}
                  renderOption={(props, option, { inputValue }) => {
                    const matches = match(option.title, inputValue, {
                      insideWords: true,
                    });
                    const parts = parse(option.title, matches);

                    return (
                      <li {...props}>
                        <div>
                          {parts.map((part, index) => (
                            <span
                              key={index}
                              style={{
                                fontWeight: part.highlight ? 700 : 400,
                              }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      </li>
                    );
                  }}
                />
              </FormControl>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
